import { Box } from '@mui/material';
import ListAltIcon from '@mui/icons-material/ListAlt';
import {Button} from "@origamirisk/origami-storybook";

interface JobsButtonProps {
    activeJobsCount: number;
    onClick: () => void;
    disabled?: boolean;
}

export function JobsButton({ activeJobsCount, onClick, disabled = false }: JobsButtonProps) {
    const hasActiveJobs = activeJobsCount > 0;

    return (
        <Button
            color="secondary"
            variant="contained"
            size="md"
            onClick={onClick}
            disabled={disabled}
            sx={{
                minWidth: hasActiveJobs ? '120px' : '100px',
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <ListAltIcon sx={{ fontSize: 20 }} />
                {hasActiveJobs ? (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                        <span>Jobs</span>
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                minWidth: '18px',
                                height: '18px',
                                borderRadius: '2px',
                                backgroundColor: '#1e88e5',
                                color: '#fff',
                                fontSize: '11px',
                                fontWeight: 700,
                                px: 0.5,
                                ml: 1.5,
                                animation: 'pulse 2s ease-in-out infinite',
                                '@keyframes pulse': {
                                    '0%, 100%': {
                                        transform: 'scale(1)',
                                        opacity: 1
                                    },
                                    '50%': {
                                        transform: 'scale(1.1)',
                                        opacity: 0.9
                                    }
                                }
                            }}
                        >
                            {activeJobsCount}
                        </Box>
                    </Box>
                ) : (
                    <span>Jobs</span>
                )}
            </Box>
        </Button>
    );
}
